import { render, staticRenderFns } from "./PayrollReporting.vue?vue&type=template&id=6965938b"
import script from "./PayrollReporting.vue?vue&type=script&lang=js"
export * from "./PayrollReporting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports